import { render, staticRenderFns } from "./EditOrder.html?vue&type=template&id=d3593d1a&"
import script from "./EditOrder.js?vue&type=script&lang=js&"
export * from "./EditOrder.js?vue&type=script&lang=js&"
import style0 from "./EditOrder.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports